export const COUNTRY_CURRENCY_MAP = {
  Грузия: '₾',
  Россия: '₽',
};

export const CITY_RU_TO_ENG = { Тбилиси: 'Tbilisi' };
